module.exports = "<h2>Stücke registrieren\r\n  <vb-rfid-reader></vb-rfid-reader>\r\n</h2>\r\n\r\n\r\n<vb-assets-list>\r\n\r\n</vb-assets-list>"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/asset-management/register-assets/register-assets.component.html
// module id = ./src/app/store-management/asset-management/register-assets/register-assets.component.html
// module chunks = main